{
  "hero": {
    "title": "Dienste",
    "cta": "Kontaktieren Sie uns"
  },
  "services": [
    {
      "number": "01",
      "title": "Strategische UI/UX & Frontend-Beratung",
      "description": "Für komplexe Plattformen und technologiegetriebene Unternehmen. Mit 20 Jahren Erfahrung biete ich hochrangige technische Führung für groß angelegte Projekte.",
      "items": [
        {
          "title": "Interface-Audits",
          "description": "Identifizierung von Reibungspunkten in komplexen Nutzerreisen."
        },
        {
          "title": "Design-Systeme",
          "description": "Aufbau skalierbarer Figma-zu-Code-Bibliotheken (React/Vue)."
        },
        {
          "title": "Architektur & Performance",
          "description": "Sicherstellen, dass Ihr Frontend genauso schnell wie schön ist."
        }
      ]
    },
    {
      "number": "02",
      "title": "Ganzheitliches Brand Engineering",
      "description": "Vom ersten Entwurf bis zum finalen Deployment. Ich glaube nicht an \"getrenntes\" Branding. Ich baue Ihre visuelle Identität und Ihren digitalen Storefront als einen einzigen, lebendigen Organismus.",
      "items": [
        {
          "title": "Identitätsdesign",
          "description": "Logos, Typografie und Brand Books, die sich ins Web übertragen lassen."
        },
        {
          "title": "Hochleistungs-Web-Entwicklung",
          "description": "Maßgeschneiderte Websites, die für Conversion und Geschwindigkeit gebaut sind."
        },
        {
          "title": "Digitale Ökosysteme",
          "description": "Sicherstellen, dass Ihre Marke auf einem Smartphone genauso wirkt wie auf einem Desktop."
        }
      ]
    },
    {
      "number": "03",
      "title": "Kinematische Content-Produktion",
      "description": "Das fehlende Glied im modernen Geschäft. Ich produziere hochwertige Videos und Fotografie, die die meisten Agenturen erwarten, dass Sie selbst bereitstellen. Ich gestalte Ihre Website um den Content, den ich drehe.",
      "items": [
        {
          "title": "Markengeschichten",
          "description": "Kinematische Videos, die Ihr Unternehmen vermenschlichen."
        },
        {
          "title": "Produktdemo & Erklärvideos",
          "description": "Komplexe Technologie einfach verständlich machen."
        },
        {
          "title": "Asset-Bibliotheken",
          "description": "Eine monatliche Bank aus professionellen Fotos und Kurzvideos (Reels/TikTok), um Ihre Social Media aktiv zu halten."
        }
      ]
    }
  ]
}
